import { Grid } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

export const Container = styled(Grid)({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  gap: "5%",
});

export const CounterDetailsContainer = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
});
export const CounterDetail = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});
export const CounterDetailDays = styled(Grid)({
  display: "flex",
  alignItems: "end",
});

export const CounterDetailTitle = styled(Grid)(({ theme }) => ({
  display: "flex",
  width: "80%",
  alignItems: "baseline",
  color: theme.palette.text.secondary,
  gap: "5px",
  "& svg": {
    fontSize: "7px",
  },
}));

export const BalanceContainer = styled(Grid)(({ theme }) => ({
  width: "20%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  borderLeft: `1px solid ${lighten(theme.palette.text.disabled, 0.5)}`,
  paddingLeft: "15px",
}));

export const SegmentsContainer = styled(Grid)({
  display: "flex",
  width: "100%",
});
export const Segment = styled(Grid)({
  padding: "3px",
  borderRadius: "3px",
});
